


































































import { Component, Prop, Vue } from 'vue-property-decorator';
import InfoCard from '../InfoCard.vue';

@Component({
    name: 'InfoSection',
    components: {
        InfoCard,
    },
})
export default class InfoSection extends Vue {
    openedInfoCard: number = -1;

    handleInfoCardClicked(index: number) {
        if (this.openedInfoCard == index)
        {
            this.openedInfoCard = -1;
        }
        else
        {
            this.openedInfoCard = index;
        }
    }
}
